import { DaysOfWork } from "./DaysOfWork";
import { ESSENTIAL_DESCRIPTIONS } from "./employeeRecordConfig";

type EmployeeRecordDaysOfWorkProps = {
    daysOfWork: string[];
    onChange: (label: string, data: string[]) => void;
}

export const EmployeeRecordDaysOfWork = ({daysOfWork, onChange} : EmployeeRecordDaysOfWorkProps) => {
    return (
        <div className="app-employee-record-property">
            <div className="app-employee-record-left">
                <div className="app-employee-record-label">
                    Days of Work
                </div>
            </div>
            <div className="app-employee-record-middle">
                <DaysOfWork 
                    daysOfWork={daysOfWork}
                    onChange={(days: string[]) => {
                        onChange("daysOfWork", days);
                    }}
                />
            </div>
            <div className="app-employee-record-right">
                {ESSENTIAL_DESCRIPTIONS.daysOfWork}

            </div>
        </div>
    )
}